import { Injectable, inject } from '@angular/core';
import {PlatformService} from '../auth/services/platform.service';
import {LetterResponse} from '../model/letter-response';
import {Filesystem, Directory} from '@capacitor/filesystem';
import {FileOpener} from '@capawesome-team/capacitor-file-opener';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private platformService = inject(PlatformService);


  downloadFile(letterResponse: LetterResponse) {
    if (!letterResponse || !letterResponse.letterContent) {
      console.warn('[FileService] downloadFile: no content');
      return;
    }

    if (this.platformService.isMobile()) {
      this.downloadFileMobile(letterResponse).catch(err =>
        console.error('[FileService] downloadFileMobile unhandled error:', err)
      );
    } else {
      const byte = this.base64ToArrayBuffer(letterResponse.letterContent, letterResponse.mimeType);
      const blob = new Blob([byte], { type: 'application/pdf' });
      window.open(URL.createObjectURL(blob), '_blank');
    }
  }

  private async downloadFileMobile(letterResponse: LetterResponse) {
    try {
      let base64Content = letterResponse.letterContent.replace(/\s/g, '');
      if (letterResponse.mimeType === 'application/xml') {
        const decoded = window.atob(base64Content);
        const pdfBase64 = decoded.substring(
          decoded.indexOf('<PDFDocument>') + 13,
          decoded.lastIndexOf('</PDFDocument>')
        );
        base64Content = pdfBase64.replace(/\s/g, '');
      }

      const fileName = `myabvv_${Date.now()}.pdf`;

      const result = await Filesystem.writeFile({
        path: fileName,
        data: base64Content,
        directory: Directory.Cache
      });

      await FileOpener.openFile({
        path: result.uri,
        mimeType: 'application/pdf'
      });
    } catch (error) {
      console.error('[FileService] Mobile PDF download failed:', error);
    }
  }

  base64ToArrayBuffer(base64File: string, mimeType: string): ArrayBuffer {
    let result: ArrayBuffer = null;

    if (null != base64File) {
      let binary_string = window.atob(base64File.replace(/\s/g, ''));
      if (mimeType === 'application/xml' && mimeType != null) {
        binary_string = binary_string.substring(binary_string.indexOf('<PDFDocument>') + 13, binary_string.lastIndexOf('</PDFDocument>'));
        binary_string = window.atob(binary_string.replace(/\s/g, ''));
      }

      const bytes = new Uint8Array(binary_string.length);

      for (let i = 0; i < binary_string.length; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }

      result = bytes.buffer as ArrayBuffer;
    }

    return result;
  }
}
